module.exports = __webpack_public_path__ + "static/img/《客户告知书》20260319-图片-1.390a2eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/《客户告知书》20260319-图片-1.jpg
// module id = uBEK
// module chunks = 1